<template>
    <div class="callus-box">
        <div class="callus-header HeaderBar Headerbg" :class='{ active: active, scrool: scrool }'>
            <div class="callus-header-main" @click="changeSidebar()">
                <i v-show="!main" class="iconfont x-a-maenbtn"></i>
                <i v-show="main" class="iconfont x-a-maenbtnx"></i>
            </div>
            <div class="callus-header-logo">
                <img v-show="zhactive" @click="changeIndex()" src="@/assets/images/index-svg-black.svg" alt="">
                <img v-show="enactive" @click="changeIndex()" src="@/assets/images/index-svg-black-en.svg" alt="">
            </div>
            <div class="callus-header-En">
                <span v-show="skill">技术支持</span>
                <span class="spancolor" :class='{ spanactive: zhactive }' @click="setLanguage('zh')">中文</span>
                <span> <el-divider direction="vertical"></el-divider></span>
                <span class="spancolor" :class='{ spanactive: enactive }' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="callus-aside AsideBar" :class="{ AsideBaractive: mianOpen }">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' :class="{ active: item.active }"
                        @click="tochangeli(item)">
                        <span class="spanul">{{ $t(item.name) }}</span> &nbsp;<span class="spanul2"
                            v-show="i == 1"></span>
                        <ul :class='{ active: item.show === true }' :ref="`list${i}`">
                            <li v-for="(a, index) in item.list" :key="index" @click.stop="doThis(a)">
                                <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="AsideBar-bottom">
                <span class="spancolor" :class='{ spanactive: zhactive }' @click="setLanguage('zh')">中文</span>
                <span class="spancolor" :class='{ spanactive: enactive }' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="Center">
            <div class="HeaderI"></div>
            <div class="Center-box">
                <div class="Center-box-left">
                    <div class="Sider">
                        <ul class="Sider-ul">
                            <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' :class="{ active: item.active }"
                                @click="tochangeli(item)">
                                <span class="spanul">{{ $t(item.name) }}</span> &nbsp;<span class="spanul2"
                                    v-show="i == 1"></span>
                                <ul :class='{ active: item.show === true }' :ref="`listlg${i}`">
                                    <li v-for="(a, index) in item.list" :key="index" @click.stop="doThis(a)">
                                        <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                        <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="Center-box-right">
                    <div class="callus-center">
                        <div class="callus-center-top" :class="{ calluscenter: calluscenter }">
                            <div class="callus-center-top-map" id="container"></div>
                        </div>
                        <div class="callus-center-bottom" :class="{ calluscenter: calluscenter }">
                            <div class="callus-center-bottomBox">
                                <!-- <div class="callus-center-bottomBox-header"><span><i class="iconfont cs-shuxian"></i></span> X Speaker 品牌介绍</div> -->
                                <!-- <div class="callus-center-bottomBox-text">做某事很容易，当它就像之前的事情一样时更容易。 还有那之前的那个。 但是，就像所有美好的事物一样，这一切都是从头开始的。 没有笔记， 还有那之前的那个。 但是，就像所有美好的事物一样，这一切都是从头开始的。 没有笔记。 没有蓝图。 没有地图可以找到我们回去的路。</div> -->
                                <div v-show="zhactive">
                                    <p>如有任何问题请与我们联系！</p>
                                    <p>为您在线解答售前(5×8)、售后咨询(5 × 8)服务。</p>
                                    <p>电话：4006009903</p>
                                    <br>
                                    <p>地址：深圳市南山区沙河街道高发社区侨香路4068号智慧广场A栋1101</p>
                                    <p>邮编：518053</p>
                                    <p>电话总机：0755-82732010</p>
                                    <p>电邮：hrsz@x-speaker.com</p>
                                </div>
                                <div v-show="enactive">
                                    <p>If you have any questions, please contact us!</p>
                                    <p>Answer pre-sales questions online for you (5 × 8) After sales consultation (5 ×
                                        8) service.</p>
                                    <p>Tel: 4006009903</p>
                                    <br>
                                    <p>Address: 1101, building a, smart Plaza, No. 4068, Qiaoxiang Road, Gaofa
                                        community, Shahe street, Nanshan District, Shenzhen</p>
                                    <p>Postal Code: 518053</p>
                                    <p>Switchboard: 0755-82732010</p>
                                    <p>Email：hrsz@x-speaker.com</p>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div class="common-width">
                        <div class="Bottom">
                            <div class="Bottom-list">
                                <div v-for="(item, i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)"
                                    @mouseleave="mouseLeave(i)">
                                    <a href="javascript:;">
                                        <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                            <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                                <div class="Triangle-down"></div>
                                                <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                                <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                            </div>
                                        </i>
                                    </a>
                                </div>
                                <!-- <share :config='config'></share> -->
                            </div>
                            <div class="Bottom-divider">
                                <el-divider></el-divider>
                            </div>
                            <div class="Bottom-icp">
                                <div><a href="javascript">{{ $t('lang.Record_1') }}</a></div>
                                <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a>
                                </div>
                                <div class="b_span">
                                    <img src="@/assets/images/logo-police.png" alt="">
                                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338"
                                        rel="noreferrer" target="_blank">粤公网安备44040402000338号</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="BottomLeft">
            <div class="BottomLeft-box">
                <div class="BottomLeft-list">
                    <div v-for="(item, i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)"
                        @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                    <div class="Triangle-down"></div>
                                    <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                    <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                    <!-- <share :config='config'></share> -->
                </div>
                <div class="BottomLeft-icp">
                    <div><a href="javascript:;">{{ $t('lang.Record_1') }}</a></div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a></div>
                    <div class="b_span">
                        <img src="@/assets/images/logo-police.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338" rel="noreferrer"
                            target="_blank">粤公网安备44040402000338号</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="all-center" :class="{ openicon: openicon }">
            <div class="all-center-box" @click="changeiconto"></div>
            <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
            <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
        </div>
    </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { product, faqsList } from "@/api/index";
import { mapGetters } from "vuex";
import { Localurl } from "@/utils/validate";
export default {
    name: 'index',
    computed: {
        ...mapGetters(["languageType"])
    },
    components: {


    },
    data() {
        return {
            idxi: -1,
            zhactive: true,
            enactive: false,
            main: false,
            mianOpen: false,
            active: false,
            skill: false,
            headerbarlistactive: true,
            calluscenter: false,
            openicon: false,
            map: null,
            scrool: false,
            icons: ['x-wechat', 'x-jd', 'x-tm'],
            list: [
                { name: 'lang.index_li1', url: { name: '/detail', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li2', url: { name: '/list', open: false }, list: [], show: false, active: false },
                { name: 'lang.index_li3', url: { name: '/about', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li4', url: { name: '/position', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li5', url: { name: '/callus', open: false }, list: [], show: false, active: true },
            ],
            mainliHeight: 40,
            config: {
                sites: ['qq', 'wechat', 'linkedin', 'facebook', 'twitter'],
            }

        }
    },
    mounted() {
        setTimeout(() => {
            this.active = true
            this.getWidth();
            this.openicon = false
        }, 500)
        this.setLanguage(this.languageType)
        Localurl("?lang=" + this.languageType);
        this.initMap();
    },

    methods: {
        initMap() {
            AMapLoader.load({
                key: "4936b6efe75f61693f8c5d1f9fb5f952",             // 申请好的Web端开发者Key，首次调用 load 时必填
                version: "",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [''],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
                this.map = new AMap.Map("container", {  //设置地图容器id
                    viewMode: "3D",    //是否为3D地图模式
                    zoom: 10,           //初始化地图级别
                    center: [113.98215, 22.55055], //初始化地图中心点位置
                });
                // this.map.setZoom(12); 
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(113.98215, 22.55055),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                    title: '深圳惠威电声科技有限公司'
                });
                this.map.add(marker);
                this.opemInfo()



                var info = [];

                if (this.$i18n.locale == 'zh') {
                    info.push("<div class='input-card content-window-card'><div><img style='width:50%' src=\" /img/index-svg-black.628a0785.svg \"/></div> ");
                    info.push("<div style=\"padding:3px 0px 0px 0px;\">");
                    info.push("<div class='input-box input-phone'>电话 : 4006009903  </br> 电话总机 : 0755-82732010  </br> 邮编 : 518053  </br> 电邮 : hrsz@x-speaker.com</div>");
                    info.push("<div class='input-box input-addree'>地址 :深圳市南山区沙河街道高发社区侨香路4068号智慧广场A栋1101</div></div></div>");
                } else {
                    info.push("<div class='input-card content-window-card'><div><img style='width:50%' src=\" /img/index-svg-black-en.03c5655a.svg \"/></div> ");
                    info.push("<div style=\"padding:3px 0px 0px 0px;\">");
                    info.push("<div class='input-box input-phone'>Tel : 4006009903  </br> Switchboard : 0755-82732010  </br>Postal Code : 518053  </br>Email : hrsz@x-speaker.com</div>");
                    info.push("<div class='input-box input-addree'>Address: 1101, building a, smart Plaza, No. 4068, Qiaoxiang Road, Gaofa community, Shahe street, Nanshan District, Shenzhen</div></div></div>");
                }

                var infoWindow = new AMap.InfoWindow({
                    content: info.join("")  //使用默认信息窗体框样式，显示信息内容
                });
                infoWindow.open(this.map, this.map.getCenter());

                var toolBar = new AMap.ToolBar({
                    visible: false,
                    position: {
                        bottom: '110px',
                        right: '40px'
                    }
                })
                this.map.addControl(toolBar);


            }).catch(e => {
                console.log(e);
            })
        },
        opemInfo() {

            // this.map.add(info)
        },
        changeSidebar() {
            this.main = !this.main
            this.mianOpen = !this.mianOpen
        },
        changeIndex() { this.$router.push({ path: '/index', query: { lang: this.languageType } }) },
        getWidth() {
            if (window.innerWidth < 992 && this.headerbarlistactive) {
                this.headerbarlistactive = false
                this.calluscenter = true
            }
            if (window.innerWidth >= 992 && !this.headerbarlistactive) {
                this.headerbarlistactive = true
                this.calluscenter = false
                this.main = false
                this.mianOpen = false
            }
            if (window.innerWidth >= 468 && !this.headerbarlistactive) {
                this.openicon = false
            }
        },
        tochangeli(item) {
            if (this.$route.path == item.url.name) { return; }
            if (item.url.open) { this.$router.push(item.url.name); }
            if (!item.url.open) { this.$router.push({ path: item.url.name, query: { id: item.list[0].id } }); }
        },
        // leaveli(index){

        //     this.$refs[`list${index}`][0].style.height = '0'
        //     this.$refs[`listlg${index}`][0].style.height = '0'
        // },
        // enterli(item,index){
        //     this.list.map((i,mapidx)=>{
        //         if(item.show !== i.show){
        //             i.show = false 
        //             this.$refs[`list${mapidx}`][0].style.height = '0'
        //              this.$refs[`listlg${mapidx}`][0].style.height = '0'
        //         }
        //     })
        //     item.show = !item.show;
        //     this.$refs[`list${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        //     this.$refs[`listlg${index}`][0].style.height =this.list[index].list.length * this.mainliHeight +'px';
        // },
        doThis(item) {
            if (item.open) { this.$router.push({ path: item.namelink, query: { id: item.id } }); }
        },
        setLanguage(val) {
            this.$store.dispatch("index/language", { lang: val })
            Localurl("?lang=" + this.languageType);
            this.$i18n.locale = val
            if (val == 'zh') {
                this.zhactive = true
                this.enactive = false
                document.title = '联系我们'
            } else {
                this.enactive = true
                this.zhactive = false
                document.title = 'CONTACT US'
            }
            this.initMap();
        },
        mouseEnter(i) { this.idxi = i },
        mouseLeave() { this.idxi = -1 },
        iconto(i) {
            if (i === 0 && !this.headerbarlistactive) { this.openicon = true }
            if (i === 1) { window.open("https://mall.jd.com/index-12191261.html", "_black") }
            if (i === 2) { window.open("https://x-speaker.tmall.com/?spm=a217wi.openworkbeanchtmall.widgets.2.41e65e16MbeHsw", "_black") }
        },
        changeiconto() { this.openicon = false },
        fetchData() {
            product({ pageSize: 20 }).then((res) => {
                if (res.code == 200) {
                    var data = res.data.list;
                    for (var i = 0; i < data.length; i++) {
                        this.list[1].list.push({
                            name: data[i].name,
                            name_en: data[i].name_en,
                            id: data[i].id,
                            namelink: '/list',
                            open: true,
                        })
                    }
                }

            });
            faqsList().then((res) => {
                var data = res.data.list
                for (var i = 0; i < data.length; i++) {
                    this.list[3].list.push({
                        name: data[i].name,
                        name_en: data[i].name_en,
                        id: data[i].id,
                        namelink: '/position',
                        open: true,
                    })
                }
            })
        },
        handleScroll() {
            if (window.pageYOffset > 20) {
                this.scrool = true
            } else {
                this.scrool = false
            }
        },
    },
    created() {
        this.fetchData();
        document.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.getWidth);
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.getWidth);
    },
}
</script>
<style>
.callus-center {
    position: relative;
    height: 800px;
}

.callus-center-top,
.callus-center-bottom {
    position: absolute;
    left: 0;
    width: 100%;
    transition: .3s ease-in-out
}

.callus-center-top {
    top: 0;
    height: 70%;
    padding: 0 0 0 20px;
    overflow: hidden;
}

.callus-center-bottom {
    top: 70%;
    height: 30%;
    overflow: hidden;
}

.callus-center-top.calluscenter {
    top: 30%;
    height: 70%;
}

.callus-center-bottom.calluscenter {
    top: 0;
    height: 30%;
}

.callus-center-top-map {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
}

.callus-center-bottomBox {
    padding: 20px;
    font-size: 14px;
    overflow: hidden;
}

.callus-center-bottomBox-header {
    height: 60px;
    padding: 0 30px;
    line-height: 60px;
}

.callus-center-bottomBox-text {
    width: 60%;
    padding: 0 30px
}

.callus-header-main i {
    display: none
}

@media (max-width: 1200px) {}

@media (max-width: 992px) {
    .Center-box-left {
        display: none
    }

    .callus-center-bottomBox-text {
        width: 100%;
    }

    .callus-center-bottomBox {
        padding: 20px
    }

    .callus-header-main i {
        display: block
    }

    .callus-header-En span {
        display: none
    }

    .callus-center-top {
        padding: 0 0px;
    }
}

@media (max-width: 468px) {
    .callus-header-main i {
        display: block
    }
}

@media (max-width:1200px) {

    .list-img-box,
    .list-img-box img {
        width: 800px;
        height: 800px;
    }
}

@media (max-width:1084px) {

    .list-img-box,
    .list-img-box img {
        width: 680px;
        height: 680px;
    }
}

@media (max-width:992px) {
    .callus-center {
        height: 750px;
    }

    .callus-center-top.calluscenter {
        top: 250px;
        height: 500px;
    }

    .callus-center-bottom.calluscenter {
        top: 0;
        height: 250px;
    }
}

@media (max-width:778px) {
    .callus-center {
        height: 650px;
    }

    .callus-center-top.calluscenter {
        top: 250px;
        height: 400px;
    }

    .callus-center-bottom.calluscenter {
        top: 0;
        height: 250px;
    }
}

@media (max-width:578px) {
    .callus-center {
        height: 600px;
    }

    .callus-center-top.calluscenter {
        top: 300px;
        height: 300px;
    }

    .callus-center-bottom.calluscenter {
        top: 0;
        height: 300px;
    }
}

@media (max-width:468px) {

    .list-img-box,
    .list-img-box img {
        width: 320px;
        height: 320px;
    }
}

.callus-center-bottomBox p {
    font-size: 14px;
}



.input-phone {
    font-size: 14px;
}

.input-addree {
    font-size: 12px;
}

.input-box {
    margin-bottom: 10px;
}

.Bottom-icp {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
}

.b_span img {
    width: 13px;
    height: 13px;
    object-fit: cover;
}
</style>
